import { css, fillOutlined, circle, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const OOZE = 0x6abf6a; // dividing-cell green

/**
 * B13 Splitter — a gelatinous core that halves at every quarter of
 * health. One blob sprite, scaled per generation by the boss. Frame 0 whole /
 * frame 1 about-to-split (a seam pinches across it). docs/02 boss pool.
 */
export const bossSplitterBody: ProceduralDef = {
  key: 'boss/splitter/body',
  width: 150,
  height: 150,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const splitting = frame === 1;

    // Wet glow
    const halo = ctx.createRadialGradient(c, c, 18, c, c, c);
    halo.addColorStop(0, 'rgba(106,191,106,0.35)');
    halo.addColorStop(1, 'rgba(106,191,106,0)');
    circle(ctx, c, c, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Wobbly blob body (lumpy circle)
    const r = 52;
    ctx.beginPath();
    for (let i = 0; i <= 16; i++) {
      const a = (Math.PI * 2 * i) / 16;
      const lump = r + Math.sin(a * 3) * 5 + Math.cos(a * 5) * 3;
      const x = c + Math.cos(a) * lump;
      const y = c + Math.sin(a) * lump;
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.closePath();
    fillOutlined(ctx, OOZE, 5);

    // Internal nuclei (two — it always wants to divide)
    for (const ox of [-16, 16]) {
      circle(ctx, c + ox, c, 11);
      ctx.fillStyle = css(shade(OOZE, 0.6));
      ctx.fill();
      circle(ctx, c + ox - 3, c - 3, 4);
      ctx.fillStyle = 'rgba(230,255,230,0.85)';
      ctx.fill();
    }

    // Pinch seam when about to split
    if (splitting) {
      ctx.strokeStyle = css(shade(OOZE, 0.45));
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(c, c - r * 0.7);
      ctx.lineTo(c, c + r * 0.7);
      ctx.stroke();
    }
    void h;
  },
};
